// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IFundIdFormulaPropertyDto
 */
export interface IFundIdFormulaPropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IFundIdFormulaPropertyDto
     */
    fund_id_formula?: string;
    /**
     * 
     * @type {string}
     * @memberof IFundIdFormulaPropertyDto
     */
    fund_id_formula_state?: IFundIdFormulaPropertyDtoFundIdFormulaStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IFundIdFormulaPropertyDtoFundIdFormulaStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IFundIdFormulaPropertyDto interface.
 */
export function instanceOfIFundIdFormulaPropertyDto(value: object): value is IFundIdFormulaPropertyDto {
    return true;
}

export function IFundIdFormulaPropertyDtoFromJSON(json: any): IFundIdFormulaPropertyDto {
    return IFundIdFormulaPropertyDtoFromJSONTyped(json, false);
}

export function IFundIdFormulaPropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IFundIdFormulaPropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'fund_id_formula': json['fund_id_formula'] == null ? undefined : json['fund_id_formula'],
        'fund_id_formula_state': json['fund_id_formula_state'] == null ? undefined : json['fund_id_formula_state'],
    };
}

export function IFundIdFormulaPropertyDtoToJSON(json: any): IFundIdFormulaPropertyDto {
    return IFundIdFormulaPropertyDtoToJSONTyped(json, false);
}

export function IFundIdFormulaPropertyDtoToJSONTyped(value?: IFundIdFormulaPropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fund_id_formula': value['fund_id_formula'],
        'fund_id_formula_state': value['fund_id_formula_state'],
    };
}

